import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@components/base'

interface RangeStateConfig {
  minValue: number
  maxValue: number
  color: string
  status: string
}

export interface ArcIndicatorStateConfigs {
  rangeConfigs: RangeStateConfig[]
  noDataAvailableConfig: Pick<RangeStateConfig, 'color' | 'status'>
}

export interface ArcIndicatorProps {
  title: string
  value?: number
  stateConfig: Pick<RangeStateConfig, 'color' | 'status'> | undefined
}

export const ArcIndicatorInfo = ({ title, value, stateConfig }: ArcIndicatorProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.infoContainer}>
      <Text type="title-1" style={styles.value}>
        {value ?? 'N/A'}
      </Text>
      <Text type="small" bold style={[styles.status, { color: stateConfig?.color }]}>
        {stateConfig?.status}
      </Text>
      <Text type="regular" style={styles.title}>
        {title}
      </Text>
    </View>
  )
}

const themedStyles = StyleService.create({
  title: {
    textAlign: 'center',
    color: 'theme.text.secondary',
  },
  status: {
    marginTop: -4,
    textAlign: 'center',
  },
  value: {
    textAlign: 'center',
  },
  infoContainer: {
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
})
